import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, ModalBody, ModalWrapper } from './_core/Modal';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { UserModalCloseBtn } from './_core/UserModal';
import LogoCircle from './_core/LogoCircle';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGivingAmount } from 'redux/actions';

const Banner = styled.div`
    background-color: ${props => props.backgroundColor || '#e3ecec'};
    border-top: 1px solid #dee4e4;
    border-bottom: 1px solid #dee4e4;
    color: #000;
    padding: 5px 15px;

    font-size: 14px;

    display: flex;
    justify-content: center;
    gap: 5px;
    align-items: center;

    p {
        margin: 0;
    }
`;

const InfoBtn = styled.button`
    background: none;
    border: none;
    color: #000;
    text-decoration: underline;
    cursor: pointer;
`;

const GivingModalWrapper = styled(ModalWrapper)`
    border-radius: 15px;
    max-width: 450px;
`;

const GivingModalBody = styled(ModalBody)`
    color: #000;
    text-align: center;

    h2 {
        margin: 10px 0 0 0;
    }

    p {
        text-align: left;
        font-size: 15px;
    }

    a {
        color: #000;
        text-decoration: underline;
    }

`;

const GivingBanner = ({ backgroundColor }) => {
    // Temp removal
    return null;
    
    // const [modalOpen, setModalOpen] = useState(false);
    // const { loading, givingAmount } = useSelector(state => state.giving);
    // const dispatch = useDispatch();

    // useEffect(() => {
    //     dispatch(fetchGivingAmount());
    // }, [dispatch]);

    // return (
    //     <>
    //          <Banner backgroundColor={backgroundColor}>
    //             <p>
    //                 {loading ? <em>Loading</em> : <strong>{givingAmount}</strong>}
    //                 {` `}raised for high impact charities
    //             </p>
    //             <InfoBtn onClick={() => setModalOpen(true)} aria-label="More information about giving">
    //                 <FontAwesomeIcon icon={faInfoCircle} />
    //             </InfoBtn>
    //         </Banner>
    //         <Modal open={modalOpen} onClick={() => setModalOpen(!modalOpen)}>
    //             <GivingModalWrapper>
    //                 <UserModalCloseBtn onClick={() => setModalOpen(!modalOpen)}>&times;</UserModalCloseBtn>
    //                 <GivingModalBody>
    //                     <LogoCircle size="small" />
    //                     <h2>JPBMethod Giving Pledge</h2>
    //                     <p>JPBMethod donates 5% of gross revenue to high-impact charities with the guidance of <a href="https://www.givewell.org/" target="_blank" rel="noopener noreferrer">GiveWell</a>.</p>
    //                     <p>GiveWell is a nonprofit whose mission is to identify charities where each dollar is maximally effective at saving lives.</p>
    //                     <p>Part of my personal mission to is to help normalize automated giving, and I believe no profitable company is too small to start giving.</p>
    //                     <p>When you make any payment on this site, you automatically donate 5% of that payment toward life-saving interventions.</p>
    //                 </GivingModalBody>
    //             </GivingModalWrapper>
    //         </Modal>
    //     </>
       
    // );
};

export default GivingBanner;
